import { useState } from "react";
import { CustomerDeliveryLocation } from "dora-contracts";
import { EditIconButton, DeleteOutlinedCrossIconButton } from "../../buttons";
import { Home } from "@mui/icons-material";
import "./SavedLocationRow.css";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../redux-store";
import { deleteCustomerDeliveryLocation } from "../../../ducks/data/economics/customer-delivery-locations";
import GenericPromptDialog from "../GenericPromptDialog/GenericPromptDialog";
import EditDeliveryAddressDialog from "../../EditDeliveryAddressDialog";

const DeliveryLocationRow = ({
  location,
}: {
  location: CustomerDeliveryLocation;
}) => {
  const { t } = useTranslation(["invoicing", "components"]);
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] =
    useState(false);
  const [deleting, setDeleting] = useState(false);

  // Show the Dora name; fall back to the address for locations saved before
  // the name field existed.
  const label =
    location.name ||
    [location.address, location.postalCode, location.city, location.country]
      .filter(Boolean)
      .join(", ") ||
    location.number;

  const onConfirmDelete = async () => {
    setDeleting(true);
    try {
      await dispatch(
        deleteCustomerDeliveryLocation({
          clientId: location.clientId,
          locationId: location.id,
        })
      ).unwrap();
      setIsDeleteConfirmationOpen(false);
    } catch {
      // The deleteCustomerDeliveryLocation thunk has already reported it and shown the error toast.
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      {isEditing && (
        <EditDeliveryAddressDialog
          location={location}
          onClose={() => setIsEditing(false)}
        />
      )}
      {isDeleteConfirmationOpen && (
        <GenericPromptDialog
          title={t("invoicing:deliveryAddressDialog.deleteTitle")}
          text={t("invoicing:deliveryAddressDialog.deleteText")}
          continueText={t("components:buttonLabels.delete")}
          continueButtonColor="error"
          buttonsDisabled={deleting}
          onCancelClick={() => setIsDeleteConfirmationOpen(false)}
          onContinueClick={onConfirmDelete}
        />
      )}
      <div className="saved-location-row__container">
        <div className="saved-location-row__icon-circle">
          <div className="saved-location-row__icon">
            <Home />
          </div>
        </div>
        <div className="saved-location-row__text">
          <div>{label}</div>
          <div>{location.address}</div>
        </div>
        <div className="saved-location-row__actions">
          <EditIconButton onClick={() => setIsEditing(true)}></EditIconButton>
          <DeleteOutlinedCrossIconButton
            onClick={() => setIsDeleteConfirmationOpen(true)}
          ></DeleteOutlinedCrossIconButton>
        </div>
      </div>
    </>
  );
};

export default DeliveryLocationRow;
